import type { StageHistoryEntry } from '../api/types'
import { STAGE_LABELS, STAGE_VARIANT } from './stage-meta'
import { Chip } from '@/components/ui'

/**
 * Vertical stage_history timeline. Reads directly from the JSONB array on
 * the pipeline row; each entry has stage + at + optional note.
 */
export function StageHistoryTimeline({ entries }: { entries: StageHistoryEntry[] }) {
  if (entries.length === 0) {
    return (
      <p className="text-sm text-tertiary">No stage transitions recorded yet.</p>
    )
  }
  return (
    <ol className="flex flex-col gap-2">
      {entries.map((entry, i) => (
        <li
          key={`${entry.at}-${entry.stage}-${i}`}
          className="flex items-start gap-3 border-l border-border-subtle pl-3"
        >
          <Chip size="xs" variant={STAGE_VARIANT[entry.stage]} dot>
            {STAGE_LABELS[entry.stage] ?? entry.stage}
          </Chip>
          <div className="min-w-0 flex-1">
            <div className="text-role-metadata">
              {formatTimestamp(entry.at)}
            </div>
            {entry.note ? (
              <div className="mt-0.5 text-xs text-secondary">{entry.note}</div>
            ) : null}
          </div>
        </li>
      ))}
    </ol>
  )
}

function formatTimestamp(iso: string): string {
  try {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return iso
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
  } catch {
    return iso
  }
}
